import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import styles from './styles';

class SimpleSelect extends React.Component {
  state = {
    data: '',
    name: 'hai',
  };

  componentDidMount() {
    const { withDefault, dataArray, onValueChange } = this.props;
    if (withDefault) {
      this.setState({ data: dataArray[0] });
      onValueChange(dataArray[0]);
    };
  };

  handleChange = event => {
    const { onValueChange } = this.props;
    this.setState({ [event.target.name]: event.target.value });
    onValueChange(event.target.value);
  };

  render() {
    const { classes, dataArray, title } = this.props;
    return (
      <form className={classes.root} autoComplete="off">
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="age-simple">{title}</InputLabel>
          <Select
            value={this.state.data}
            onChange={this.handleChange}
            inputProps={{
              name: 'data',
              id: 'age-simple',
            }}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {dataArray.map((d, index) => {
              return (
                <MenuItem key={index} value={d}>{d}</MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </form>
    );
  }
}

SimpleSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  onValueChange: PropTypes.func,
  dataArray: PropTypes.array.isRequired,
  withDefault: PropTypes.bool,
  title: PropTypes.string,
};
SimpleSelect.defaultProps = {
  dataArray: [],
  onValueChange: () => {},
  withDefault: false,
  title: 'Filter By'
};

export default withStyles(styles)(SimpleSelect);



// WEBPACK FOOTER //
// ./src/app/components/Select/index.js